module.exports = __webpack_public_path__ + "img/changgui_rm.06b6905d.png";